<template>
  <div class="card border-0 rounded-0">
    <div class="card-header">
      <h3 class="text-black fw-semibold">Détails d'un bon</h3>
      <router-link to="/bons/liste-bonLivraison" class="btn btn-primary transition border-0 lh-1 fw-medium"
        style="position: absolute; right: 10px; top: 10px;">
        <i class="flaticon-left-arrow lh-1 me-1"></i>
        Retour
      </router-link>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <div class="card-head box-shadow bg-white d-flex align-items-center justify-content-between"></div>
      <div class="row">
        <!-- Bloc des informations générales -->
        <div class="col-md-8 col-xxl-8 col-sm-12 p-0">
          <h4 class="text-black fw-bold mb-10">Informations du bon</h4>
          <table class="table">
            <tbody>
              <tr>
                <td>Date Opération :</td>
                <td>{{ format_date(bonlivraison?.dateOperation) }}</td>
              </tr>
              <tr>
                <td>Référence Doc :</td>
                <td>{{ bonlivraison?.refDoc }}</td>
              </tr>
              <tr>
                <td>Type Opération :</td>
                <td>{{ bonlivraison?.typeOperation }}</td>
              </tr>
              <tr>
                <td>Client: </td>
                <td>{{ getClientName(bonlivraison?.client) }}</td>
              </tr>
            </tbody>
          </table>

          <!-- Tableau des produits -->
          <div class="row">
            <div class="col">
              <h5 class="text-black fw-bold mt-4">Les produits du bon</h5>
            </div>
          </div>
          <table class="table">
            <thead>
              <tr>
                <th>Produit</th>
                <th>Qté bon.</th>
                <th>Reste à livrer</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(produitcondibon, index) in bonlivraison?.produitcondibons" :key="index">
                <td>{{ produitcondibon.nomProd.split("|")[1] }} {{ produitcondibon.nomProd.split("|")[2] }}</td>
                <td>{{ separateur(produitcondibon.qteBon) }} {{ produitcondibon.uniteMesure }}</td>
                <td>{{ separateur(produitcondibon.resteAliv) }} {{ produitcondibon.uniteMesure }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-4 col-xxl-4 col-sm-12 p-0">
          <h5 class="text-black fw-bold mb-10">Image du Bon</h5>
          <hr> <!-- Petit trait séparateur -->
          <img v-if="bonlivraison?.imageBon" :src="getUrlApiForProductFiles(bonlivraison?.imageBon)" class="d-block w-100" alt="Photo">
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import ApiService from "@/services/ApiService";
import { BonLivraison } from "@/models/BonLivraison";
import { error, getUrlApiForProductFiles, format_date, suppression,separateur} from "@/utils/utils";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "ViewBonLivraison",
  setup() {
    const route = useRoute();
    const bonlivraison = ref<BonLivraison | null>(null);
    const medias = ref([]);
    const produitcondibons = ref([]);

    async function getBonLivraison(id: string) {
      try {
        const { data } = await ApiService.get(`/bonlivraisons/${id}`);
        console.log(data);
        if (data && data.data) {
          bonlivraison.value = data.data;
          console.log("Produitcondibons :",);
          medias.value = data.data.medias; // Récupération des médias du bonlivraison
        } else {
          throw new Error("Données du bonlivraison non trouvées.");
        }
      } catch (err) {
        error(err instanceof Error ? err.message : "Erreur lors de la récupération du bonlivraison.");
      }
    }

    // Fonction pour déterminer le nom du client à afficher
    const getClientName = (client: any) => {
      if (!client) return "Client non spécifié";

      // Si denomination existe et n’est pas vide, afficher la raison sociale
      if (client.denomination && client.denomination.trim() !== "") {
        return client.denomination;
      }
      // Sinon, afficher nom et prénom si disponibles
      const nom = client.nomClient || "";
      const prenom = client.prenomClient || "";
      return `${nom} ${prenom}`.trim() || "Client non spécifié";
    };

    onMounted(() => {
      const id = route.params.id as string;
      if (id) {
        getBonLivraison(id);
      } else {
        error("ID du bonlivraison non spécifié.");
      }
    });

    return {
      bonlivraison,
      produitcondibons,separateur,
      medias,
      suppression,
      format_date,
      getUrlApiForProductFiles,
      getClientName,
    };
  },
});
</script>

<style scoped>
.card {
  border: none;
  margin: 0;
}

.card-body {
  padding: 15px;
}

.row {
  margin: 0;
}

.table {
  border-collapse: collapse;
}

.table td {
  padding: 8px;
}

.carousel-inner img {
  max-height: 400px;
  object-fit: cover;
}
</style>